import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ModalShellComponent, ModalShellConfig } from '@shared/components/modal-shell/modal-shell.component';

export interface UserEmailEditDialogData {
  email: string;
}

@Component({
  selector: 'app-user-email-edit-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ModalShellComponent,
  ],
  template: `
    <app-modal-shell [config]="modalConfig">
      <div modal-content [formGroup]="form">
        <mat-form-field class="full-width">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" placeholder="correo@ejemplo.com" />
          <mat-icon matSuffix>email</mat-icon>
          <mat-error *ngIf="form.get('email')?.hasError('required')">
            El email es requerido
          </mat-error>
          <mat-error *ngIf="form.get('email')?.hasError('email')">
            El email debe tener un formato valido
          </mat-error>
        </mat-form-field>
      </div>

      <ng-container modal-actions>
        <button mat-button type="button" (click)="cancel()">Cancelar</button>
        <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="form.invalid">
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </ng-container>
    </app-modal-shell>
  `,
  styles: [`
    .full-width {
      width: 100%;
      min-width: 360px;
    }
  `]
})
export class UserEmailEditDialogComponent {
  readonly modalConfig: ModalShellConfig = { title: 'Editar email', size: 'md', layout: 'form' };
  form: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<UserEmailEditDialogComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) data: UserEmailEditDialogData
  ) {
    this.form = this.fb.group({
      email: [data.email, [Validators.required, Validators.email]]
    });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.get('email')!.value);
  }
}
